import {
    CommitementDetails,
    CommitmentRequirementDetails,
    Document,
} from "../../../../../../types/Dossiers";

/**
 *
 * @param commitments
 * @returns true if need to go back to client
 */
export const backOrForwardDossier = (
    commitments: CommitementDetails[]
): boolean => {
    //console.log(" commitments ", commitments);
    const allCompliantTrue = (commitment: CommitementDetails): boolean => {
        const checkCompliant = (
            commitmentRequirement: CommitmentRequirementDetails
        ): boolean => {
            const checkDocumentCompliant = (document: Document): boolean => {
                return document.compliant !== null && document.compliant;
            };
            return commitmentRequirement.documents.every(
                checkDocumentCompliant
            );
        };
        return commitment.commitmentRequirements.every(checkCompliant);
    };
    return commitments.every(allCompliantTrue);
};
